import React from 'react';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';
import Col from '../../../elements/Col';
import ImageHeader from './ImageHeader';
import Text from '../../../elements/Text';
import { formatDate } from '../../../controls/DatesRangeSelector/commons';
import { createHTMLElementFromString, transformLabel } from './../utils/utils';

const KEY_ENTER = 13;

const SectionBodyItem = (props) => {
  const {
    title,
    teaser,
    description,
    creationDate,
    meta,
    format = 'MM/DD/YYYY',
    images_path,
    showOneImage = true,
    showImage = true,
    showTitle = true,
    showTeaser = true,
    showCreationDate = false,
    showDescription = true,
    showAddress = true,
    showPhone = true,
    showWww = true,
    id,
    rowContainerSettings,
    imageContainerSettings,
    imageSettings,
    informationContainerSettings,
    informationColSettings,
    titleSettings,
    teaserSettings,
    creationDateSettings,
    contactInformationContainerSettings,
    dispatch
  } = props;
  const { address, phone, www } = meta;

  const showImageFn = () => {
    if (images_path && images_path.length > 0) {
      return showOneImage ? (
        <ImageHeader image={images_path[0]} focusable={false} {...imageSettings} />
      ) : (
        images_path.map((image) => {
          return <ImageHeader image={image} focusable={false} {...imageSettings} />;
        })
      );
    }
    return null;
  };

  const [wasMakeEnterAction, setWasMakeEnterAction] = React.useState(false);

  return (
    <Row width="100%" id={`item-${id}`} {...rowContainerSettings}>
      <Col lg="2" md="2" sm="12" xs="12" {...imageContainerSettings}>
        {showImage && showImageFn()}
      </Col>
      <Col {...informationColSettings}>
        <Box {...informationContainerSettings}>
          {showTitle && title && <Text {...titleSettings}>{title}</Text>}
          {showTeaser && teaser && <Text {...teaserSettings}>{teaser}</Text>}
          {showCreationDate && creationDate && (
            <Text {...creationDateSettings}>
              {formatDate(new Date(creationDate), format, context)}
            </Text>
          )}
          {showDescription && description && (
            <span
              className={`fr-item-section-description`}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: description
              }}
            />
          )}
          <Box {...contactInformationContainerSettings}>
            {showAddress && address && (
              <span
                className={`fr-item-section-address`}
                onClick={() => {
                  if (!wasMakeEnterAction) {
                    const addressHtmlElement = createHTMLElementFromString(address);
                    if (addressHtmlElement) {
                      dispatch({
                        type: 'CLICK_OUT_EVENTS',
                        payload: {
                          eventType: 'click',
                          anchorText: transformLabel(addressHtmlElement.textContent),
                          url: addressHtmlElement.getAttribute('href')
                        }
                      });
                    }
                  }
                  setWasMakeEnterAction(false);
                }}
                onKeyDown={(e) => {
                  if (e.keyCode === KEY_ENTER) {
                    setWasMakeEnterAction(true);
                    const addressHtmlElement = createHTMLElementFromString(address);
                    if (addressHtmlElement) {
                      dispatch({
                        type: 'CLICK_OUT_EVENTS',
                        payload: {
                          eventType: 'keypress',
                          anchorText: transformLabel(addressHtmlElement.textContent),
                          url: addressHtmlElement.getAttribute('href')
                        }
                      });
                    }
                  }
                }}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: address
                }}
              />
            )}
            {showPhone && phone && (
              <span
                className={`fr-item-section-phone`}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: phone
                }}
                onClick={() => {
                  if (!wasMakeEnterAction) {
                    const phoneHtmlElement = createHTMLElementFromString(phone);
                    if (phoneHtmlElement) {
                      dispatch({
                        type: 'CLICK_OUT_EVENTS',
                        payload: {
                          eventType: 'click',
                          anchorText: phoneHtmlElement.textContent,
                          url: phoneHtmlElement.getAttribute('href')
                        }
                      });
                    }
                  }
                  setWasMakeEnterAction(false);
                }}
                onKeyDown={(e) => {
                  if (e.keyCode === KEY_ENTER) {
                    setWasMakeEnterAction(true);
                    const phoneHtmlElement = createHTMLElementFromString(phone);
                    if (phoneHtmlElement) {
                      dispatch({
                        type: 'CLICK_OUT_EVENTS',
                        payload: {
                          eventType: 'keypress',
                          anchorText: phoneHtmlElement.textContent,
                          url: phoneHtmlElement.getAttribute('href')
                        }
                      });
                    }
                  }
                }}
              />
            )}
            {showWww && www && (
              <span
                className={`fr-item-section-www`}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: www
                }}
                onClick={() => {
                  if (!wasMakeEnterAction) {
                    const wwwHtmlElement = createHTMLElementFromString(www);
                    if (wwwHtmlElement) {
                      dispatch({
                        type: 'CLICK_OUT_EVENTS',
                        payload: {
                          eventType: 'click',
                          anchorText: wwwHtmlElement.textContent,
                          url: wwwHtmlElement.getAttribute('href')
                        }
                      });
                    }
                  }
                  setWasMakeEnterAction(false);
                }}
                onKeyDown={(e) => {
                  if (e.keyCode === KEY_ENTER) {
                    setWasMakeEnterAction(true);
                    const wwwHtmlElement = createHTMLElementFromString(www);
                    if (wwwHtmlElement) {
                      dispatch({
                        type: 'CLICK_OUT_EVENTS',
                        payload: {
                          eventType: 'keypress',
                          anchorText: wwwHtmlElement.textContent,
                          url: wwwHtmlElement.getAttribute('href')
                        }
                      });
                    }
                  }
                }}
              />
            )}
          </Box>
        </Box>
      </Col>
    </Row>
  );
};

export default SectionBodyItem;
